import React, { useEffect, useState } from 'react'
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from 'react-router-dom';
import './Packages.css'
import { deleteFeatures, emptyOneFeatures, loadFeatures } from '../../Redux/Actions/ActionPackages';
import EditFeatures from './EditFeature';
import ReactLoading from 'react-loading';
import AddToVendor from './AddToVendor';

function ShowFeatures() {
    let dispatch = useDispatch();
    let langLocal = localStorage.getItem('absherLang');
    let role = localStorage.getItem('roleA');
    const [t, i18n] = useTranslation();
    let { id } = useParams()
    let { name } = useParams()
    const [open, setOpen] = useState('')
    const [arr, setArr] = useState([]);
    const [features, setFeatures] = useState([]);
    const [openEdit, setopenEdit] = useState(false)
    const Features = useSelector(state => state.packagee.Features)
    const loadingFeatures = useSelector(state => state.packagee.loadingFeatures)
    useEffect(() => {
        dispatch(loadFeatures(id))
        return () => {
            dispatch(emptyOneFeatures());
        }
    }, [])
    const handleDelete = (idFea) => {
        dispatch(deleteFeatures(id, idFea))
    }
    const handleEdit = (arr1) => {
        const formValues = {
            id: arr1.id,
            name: arr1.name,
            name_ar: arr1.name_ar
        };
        setArr(formValues);
        setopenEdit(true);
    }
    const handleCheckboxChange = (e, featureId, featureName) => {
        const isChecked = e.target.checked;
        setFeatures(prevFeatures => {
            if (isChecked) {
                return [...prevFeatures, { feature_id: featureId, feature_name: featureName }];
            } else {
                return prevFeatures.filter(feature => feature.feature_id !== featureId);
            }
        });
    };
    const submit = event => {
        event.preventDefault();
        console.log(features)
    }
    return (
        <>
            <main>
                <div className="page_header" dir={langLocal == "ar" ? "rtl" : "ltr"} >
                    <h2>{t('features')} / {name}</h2>
                    {
                        role !== '2' && (
                            <button onClick={() => setOpen(true)} >
                                <i className="fa fa-plus" ></i>
                                <span>Add To Vendor</span>
                            </button>
                        )
                    }
                </div>
                <div className='allFea' dir={langLocal == "ar" ? "rtl" : "ltr"} >
                    {
                        loadingFeatures == false ? (
                            Features.map((ff) => {
                                return (
                                    <div className='oneFea' key={ff.id} >
                                        <img src={ff.icon} />
                                        <h3>{ff.name}</h3>
                                        <br></br>
                                        {
                                            role !== '2' && (
                                                <input
                                                    type='checkbox'
                                                    onChange={(e) => handleCheckboxChange(e, ff.id, ff.name)}
                                                />
                                            )
                                        }
                                        <div className='actionFea' >
                                            <i className='fa fa-trash trashFea' onClick={() => handleDelete(ff.id)} ></i>
                                            <i className='fa fa-edit editFea' onClick={() => handleEdit(ff)} ></i>
                                        </div>
                                    </div>
                                )
                            })
                        ) : <div className="div_loading_normal" ><ReactLoading type="spinningBubbles" color="#36ADB0" height={'7%'} width={'7%'} /></div>
                    }
                </div>
            </main>
            {
                openEdit == true ? (
                    <EditFeatures package_id={id} arr={arr} open={openEdit} setOpen={setopenEdit} />
                ) : <></>
            }
            {
                open == true ? (
                    <AddToVendor features={features} open={open} setOpen={setOpen} />
                ) : <></>
            }
        </>
    )
}

export default ShowFeatures